<template>
  <div id="document1">
    <v-btn class="ma-2 no-display" tile outlined color="warning" @click="print()">
      <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon>
    </v-btn>
    <v-row v-if="show_receipt != '' && show_receipts_btn" id="print">
      <v-col cols="12" sm="8" md="8" class="m-0 p-0" v-if="radios == 'office'">
        <v-card>
          <v-simple-table dense class="elevation-1 table-container">
            <template v-slot:default>
              <thead>
                <tr>
                  <td colspan="3">
                    <center><strong>Fee Receipt </strong></center>
                  </td>
                </tr>
                <tr>
                  <th v-if="org_basic_data.trust_logo">
                    <center>
                      <img :src="org_basic_data.trust_logo" class="logo trust-logo" alt="Trust Logo" />
                    </center>
                  </th>
                  <td>
                    <center>
                <tr v-if="org_basic_data.trust_name">
                  <strong>{{ org_basic_data.trust_name }}</strong>
                </tr>
                <tr v-if="org_basic_data.school_name">
                  <strong>{{ org_basic_data.school_name }} </strong>
                </tr>
                <tr v-if="org_basic_data.address">
                  {{
                  org_basic_data.address
                  }}
                </tr>
                <tr v-if="org_basic_data.phone">
                  Phone :
                  {{
                  org_basic_data.phone
                  }}
                </tr>
                <tr v-if="org_basic_data.email">
                  Email :
                  {{
                  org_basic_data.email
                  }}
                </tr>
                <tr v-if="org_basic_data.website">
                  Website :
                  {{
                  org_basic_data.website
                  }}
                </tr>
                </center>
                </td>
                <th v-if="org_basic_data.school_logo">
                  <center>
                    <img :src="org_basic_data.school_logo" class="logo school-logo" alt="School Logo" />
                  </center>
                </th>
                </tr>
                <!-- <tr>
                                      <td colspan="3">PRN No. : {{show_receipt.registration_number}}</td>
                                  </tr>
                                  <tr>
                                      <td colspan="3">Student Name : {{show_receipt.name}}</td>
                                  </tr>
                                  <tr>
                                      <td colspan="3">Office Copy</td>
                                  </tr>
                                  <tr>
                                      <td colspan="3">Fee Details For : {{show_receipt.ay}}</td>
                                  </tr>
                                  <tr>
                                      <td colspan="3">Standard : {{show_receipt.standard}}</td>
                                  </tr>
                                  <tr>
                                      <td colspan="3">
                                          Receipt Date : {{show_receipt.receipt_date}}
                                      </td>
                                  </tr> -->
                <tr>
                  <td colspan="1">
                    PRN No. : {{ show_receipt.registration_number }}
                  </td>
                  <td colspan="1">Student Name : {{ show_receipt.name }}</td>
                  <td colspan="1">Office Copy</td>
                </tr>
                <tr>
                  <td colspan="1">Fee Details For : {{ show_receipt.ay }}</td>
                  <td colspan="1">Standard : {{ show_receipt.standard }}</td>
                  <td colspan="1">
                    Receipt Date : {{ show_receipt.receipt_date }}
                  </td>
                </tr>
                <tr>
                  <td colspan="2"><strong>Fee Type</strong></td>
                  <td><strong> Fee Amount (Rs.)</strong></td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in show_receipt.component_list_tax_receipt" :key="item.id">
                  <td colspan="2">
                    {{ item.feescomponentacademicyear_name }}
                  </td>
                  <td>{{ item.fee_amount }}</td>
                </tr>
                <tr>
                  <td colspan="2">
                    <strong>Total Fee Amount</strong>
                  </td>
                  <td>{{ show_receipt.total_fees_amount }}.00</td>
                </tr>
                <tr>
                  <td colspan="3">
                    <v-row dense class="ml-2">
                      <strong> Amount In Words : </strong>
                      {{ toWords(show_receipt.total_fees_amount) }}
                    </v-row>
                  </td>
                </tr>
                <tr>
                  <td colspan="3">
                    <v-row dense class="ml-2">
                      <strong>Installment Wise Details</strong>
                    </v-row>
                  </td>
                </tr>
                <tr>
                  <td colspan="3">
                    <v-simple-table dense class="elevation-1">
                      <thead>
                        <tr>
                          <td>
                            <center>No.</center>
                          </td>
                          <td>
                            <center>Receipt No.</center>
                          </td>
                          <td>
                            <center>Receipt Date</center>
                          </td>
                          <td>
                            <center>Amount Paid</center>
                          </td>
                          <td>
                            <center>Transaction ID </center>
                          </td>
                          <td>
                            <center>Payment Mode</center>
                          </td>
                          <!-- <td>
                            <center>Fine</center>
                          </td> -->
                        </tr>
                      </thead>
              <tbody>
                <tr v-for="(
                            item, index
                          ) in show_receipt.student_receipt_details" :key="item.id">
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.receipt_no }}</td>
                  <td>{{ item.receipt_date }}</td>
                  <td>{{ item.amount }}</td>
                  <td>{{ item.trans_id }}</td>
                  <td>{{ item.payment_mode_name }}</td>
                  <!-- <td>{{ item.fine }}</td> -->
                </tr>
              </tbody>
          </v-simple-table>
          </td>
          </tr>
          <tr>
            <td colspan="3">
              <v-row class="ml-2 mt-2"><strong>Note : </strong></v-row>
              <v-row class="ml-2">1. Fee once paid will not be refundable</v-row>
              <v-row class="ml-2">2. Late fee will have to be paid applicable</v-row>
              <v-row class="ml-2">3. Receipt should be produced any time if required for
                verification</v-row>
              <v-row class="ml-2 mb-2">4. This is computer generated receipt no signature
                required</v-row>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <strong>
                <center></center>
              </strong>
            </td>
            <td>
              <strong>
                <center></center>
              </strong>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <strong>
                <center>Accounts Officer</center>
              </strong>
            </td>
            <td>
              <strong>
                <center>Seal</center>
              </strong>
            </td>
          </tr>
          </tbody>
</template>
</v-simple-table>
</v-card>
</v-col>
<v-col cols="12" sm="8" md="8" class="m-0 p-0 table-container" v-if="radios == 'student'">
  <v-card class="table-container" v-if="show_receipt != ''">
    <!-- <v-btn class="ma-2 no-display" tile outlined color="warning" @click="print()"> <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn> -->
    <v-simple-table dense class="elevation-1 table-container">
      <template v-slot:default>
        <thead>
          <tr>
            <td colspan="3">
              <center><strong>Fee Receipt</strong></center>
            </td>
          </tr>
          <tr>
            <th v-if="org_basic_data.trust_logo">
              <center>
                <img :src="org_basic_data.trust_logo" class="logo trust-logo" alt="Trust Logo" />
              </center>
            </th>
            <td>
              <center>
          <tr v-if="org_basic_data.trust_name">
            <strong>{{ org_basic_data.trust_name }}</strong>
          </tr>
          <tr v-if="org_basic_data.school_name">
            <strong>{{ org_basic_data.school_name }} </strong>
          </tr>
          <tr v-if="org_basic_data.address">
            {{
            org_basic_data.address
            }}
          </tr>
          <tr v-if="org_basic_data.phone">
            Phone :
            {{
            org_basic_data.phone
            }}
          </tr>
          <tr v-if="org_basic_data.email">
            Email :
            {{
            org_basic_data.email
            }}
          </tr>
          <tr v-if="org_basic_data.website">
            Website :
            {{
            org_basic_data.website
            }}
          </tr>
          </center>
          </td>
          <th v-if="org_basic_data.school_logo">
            <center>
              <img :src="org_basic_data.school_logo" class="logo school-logo" alt="School Logo" />
            </center>
          </th>
          </tr>
          <!-- <tr>   <td colspan="3">PRN No. : {{show_receipt.registration_number}}</td>
                                  </tr>
                                  <tr>
                                      <td colspan="3">Student Name : {{show_receipt.name}}</td>
                                  </tr>
                                  <tr>
                                      <td colspan="3">Student Copy</td>
                                  </tr>
                                  <tr>
                                      <td colspan="3">Fee Details For : {{show_receipt.ay}}</td>
                                  </tr>
                                  <tr>
                                      <td colspan="3">Standard : {{show_receipt.standard}}</td>
                                  </tr> 
                                  <tr>
                                      <td colspan="3">
                                          Receipt Date : {{show_receipt.receipt_date}}
                                      </td>
                                  </tr> -->
          <tr>
            <td colspan="1">
              PRN No. : {{ show_receipt.registration_number }}
            </td>
            <td colspan="1">Student Name : {{ show_receipt.name }}</td>
            <td colspan="1">Student Copy</td>
          </tr>
          <tr>
            <td colspan="1">Fee Details For : {{ show_receipt.ay }}</td>
            <td colspan="1">Standard : {{ show_receipt.standard }}</td>
            <td colspan="1">
              Receipt Date : {{ show_receipt.receipt_date }}
            </td>
          </tr>
          <tr>
            <td colspan="2"><strong>Fee Type</strong></td>
            <td><strong> Fee Amount (Rs.)</strong></td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in show_receipt.component_list_tax_receipt" :key="item.id">
            <td colspan="2">
              {{ item.feescomponentacademicyear_name }}
            </td>
            <td>{{ item.fee_amount }}</td>
          </tr>
          <tr>
            <td colspan="2">
              <strong>Total Fee Amount</strong>
            </td>
            <td>{{ show_receipt.total_fees_amount }}.00</td>
          </tr>
          <tr>
            <td colspan="3">
              <v-row dense class="ml-2">
                <strong> Amount In Words : </strong>
                {{ toWords(show_receipt.total_fees_amount) }}
              </v-row>
            </td>
          </tr>
          <tr>
            <td colspan="3">
              <v-row dense class="ml-2">
                <strong>Installment Wise Details</strong>
              </v-row>
            </td>
          </tr>
          <tr>
            <td colspan="3">
              <v-simple-table dense class="elevation-1">
                <thead>
                  <tr>
                    <td>
                      <center>No.</center>
                    </td>
                    <td>
                      <center>Receipt No.</center>
                    </td>
                    <td>
                      <center>Receipt Date</center>
                    </td>
                    <td>
                      <center>Amount Paid</center>
                    </td>
                    <td>
                      <center>Transaction ID </center>
                    </td>
                    <td>
                      <center>Payment Mode</center>
                    </td>
                    <!-- <td>
                      <center>Fine</center>
                    </td> -->
                  </tr>
                </thead>
        <tbody>
          <tr v-for="(
                            item, index
                          ) in show_receipt.student_receipt_details" :key="item.id">
            <td>{{ index + 1 }}</td>
            <td>{{ item.receipt_no }}</td>
            <td>{{ item.receipt_date }}</td>
            <td>{{ item.amount }}</td>
            <td>{{ item.trans_id }}</td>
            <td>{{ item.payment_mode_name }}</td>
            <!-- <td>{{ item.fine }}</td> -->
          </tr>
        </tbody>
    </v-simple-table>
    </td>
    </tr>
    <tr>
      <td colspan="3">
        <v-row class="ml-2 mt-2"><strong>Note : </strong></v-row>
        <v-row class="ml-2">1. Fee once paid will not be refundable</v-row>
        <v-row class="ml-2">2. Late fee will have to be paid applicable</v-row>
        <v-row class="ml-2">3. Receipt should be produced any time if required for
          verification</v-row>
        <v-row class="ml-2 mb-2">4. This is computer generated receipt no signature
          required</v-row>
      </td>
    </tr>
    <tr>
      <td colspan="2">
        <strong>
          <center></center>
        </strong>
      </td>
      <td>
        <strong>
          <center></center>
        </strong>
      </td>
    </tr>
    <tr>
      <td colspan="2">
        <strong>
          <center>Accounts Officer</center>
        </strong>
      </td>
      <td>
        <strong>
          <center>Seal</center>
        </strong>
      </td>
    </tr>
    </tbody>
    </template>
    </v-simple-table>
  </v-card>
</v-col>
</v-row>
<div id="document1">
  <v-row v-if="show_receipt != '' && show_receipts_btn && radios == 'both'" id="print">
    <v-col cols="12" sm="6" md="6" class="m-0 p-0">
      <v-card>
        <v-simple-table dense class="elevation-1 table-container">
          <template v-slot:default>
            <thead>
              <tr>
                <td colspan="3">
                  <center><strong>Fee Receipt </strong></center>
                </td>
              </tr>
              <tr>
                <th v-if="org_basic_data.trust_logo">
                  <center>
                    <img :src="org_basic_data.trust_logo" class="logo trust-logo" alt="Trust Logo" />
                  </center>
                </th>
                <td>
                  <center>
              <tr v-if="org_basic_data.trust_name">
                <strong>{{ org_basic_data.trust_name }}</strong>
              </tr>
              <tr v-if="org_basic_data.school_name">
                <strong>{{ org_basic_data.school_name }} </strong>
              </tr>
              <tr v-if="org_basic_data.address">
                {{
                org_basic_data.address
                }}
              </tr>
              <tr v-if="org_basic_data.phone">
                Phone :
                {{
                org_basic_data.phone
                }}
              </tr>
              <tr v-if="org_basic_data.email">
                Email :
                {{
                org_basic_data.email
                }}
              </tr>
              <tr v-if="org_basic_data.website">
                Website :
                {{
                org_basic_data.website
                }}
              </tr>
              </center>
              </td>
              <th v-if="org_basic_data.school_logo">
                <center>
                  <img :src="org_basic_data.school_logo" class="logo school-logo" alt="School Logo" />
                </center>
              </th>
              </tr>
              <!--  <tr>
                                      <td colspan="3">PRN No. : {{show_receipt.registration_number}}</td>
                                  </tr>
                                  <tr>
                                      <td colspan="3">Student Name : {{show_receipt.name}}</td>
                                  </tr>
                                  <tr>
                                      <td colspan="3">Office Copy</td>
                                  </tr>
                                  <tr>
                                      <td colspan="3">Fee Details For : {{show_receipt.ay}}</td>
                                  </tr>
                                  <tr>
                                      <td colspan="3">Standard : {{show_receipt.standard}}</td>
                                  </tr>
                                  <tr>
                                      <td colspan="3">
                                          Receipt Date : {{show_receipt.receipt_date}}
                                      </td>
                                  </tr> -->
              <tr>
                <td colspan="1">
                  PRN No. : {{ show_receipt.registration_number }}
                </td>
                <td colspan="1">Student Name : {{ show_receipt.name }}</td>
                <td colspan="1">Office Copy</td>
              </tr>
              <tr>
                <td colspan="1">Fee Details For : {{ show_receipt.ay }}</td>
                <td colspan="1">Standard : {{ show_receipt.standard }}</td>
                <td colspan="1">
                  Receipt Date : {{ show_receipt.receipt_date }}
                </td>
              </tr>
              <tr>
                <td colspan="2"><strong>Fee Type</strong></td>
                <td><strong> Fee Amount (Rs.)</strong></td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in show_receipt.component_list_tax_receipt" :key="item.id">
                <td colspan="2">
                  {{ item.feescomponentacademicyear_name }}
                </td>
                <td>{{ item.fee_amount }}</td>
              </tr>
              <tr>
                <td colspan="2">
                  <strong>Total Fee Amount</strong>
                </td>
                <td>{{ show_receipt.total_fees_amount }}.00</td>
              </tr>
              <tr>
                <td colspan="3">
                  <v-row dense class="ml-2">
                    <strong> Amount In Words : </strong>
                    {{ toWords(show_receipt.total_fees_amount) }}
                  </v-row>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <v-row dense class="ml-2">
                    <strong>Installment Wise Details</strong>
                  </v-row>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <v-simple-table dense class="elevation-1">
                    <thead>
                      <tr>
                        <td>
                          <center>No.</center>
                        </td>
                        <td>
                          <center>Receipt No.</center>
                        </td>
                        <td>
                          <center>Receipt Date</center>
                        </td>
                        <td>
                          <center>Amount Paid</center>
                        </td>
                        <td>
                          <center>Transaction ID </center>
                        </td>
                        <td>
                          <center>Payment Mode</center>
                        </td>
                        <!-- <td>
                          <center>Fine</center>
                        </td> -->
                      </tr>
                    </thead>
            <tbody>
              <tr v-for="(
                              item, index
                            ) in show_receipt.student_receipt_details" :key="item.id">
                <td>{{ index + 1 }}</td>
                <td>{{ item.receipt_no }}</td>
                <td>{{ item.receipt_date }}</td>
                <td>{{ item.amount }}</td>
                <td>{{ item.trans_id }}</td>
                <td>{{ item.payment_mode_name }}</td>
                <!-- <td>{{ item.fine }}</td> -->
              </tr>
            </tbody>
        </v-simple-table>
        </td>
        </tr>
        <tr>
          <td colspan="3">
            <v-row class="ml-2 mt-2"><strong>Note : </strong></v-row>
            <v-row class="ml-2">1. Fee once paid will not be refundable</v-row>
            <v-row class="ml-2">2. Late fee will have to be paid applicable</v-row>
            <v-row class="ml-2">3. Receipt should be produced any time if required for
              verification</v-row>
            <v-row class="ml-2 mb-2">4. This is computer generated receipt no signature
              required</v-row>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <strong>
              <center></center>
            </strong>
          </td>
          <td>
            <strong>
              <center></center>
            </strong>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <strong>
              <center>Accounts Officer</center>
            </strong>
          </td>
          <td>
            <strong>
              <center>Seal</center>
            </strong>
          </td>
        </tr>
        </tbody>
        </template>
        </v-simple-table>
      </v-card>
    </v-col>
    <v-col cols="12" sm="6" md="6" class="m-0 p-0 table-container">
      <v-card class="table-container" v-if="show_receipt != ''">
        <!-- <v-btn class="ma-2 no-display" tile outlined color="warning" @click="print()"> <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn> -->
        <v-simple-table dense class="elevation-1 table-container">
          <template v-slot:default>
            <thead>
              <tr>
                <td colspan="3">
                  <center><strong>Fee Receipt </strong></center>
                </td>
              </tr>
              <tr>
                <th v-if="org_basic_data.trust_logo">
                  <center>
                    <img :src="org_basic_data.trust_logo" class="logo trust-logo" alt="Trust Logo" />
                  </center>
                </th>
                <td>
                  <center>
              <tr v-if="org_basic_data.trust_name">
                <strong>{{ org_basic_data.trust_name }}</strong>
              </tr>
              <tr v-if="org_basic_data.school_name">
                <strong>{{ org_basic_data.school_name }} </strong>
              </tr>
              <tr v-if="org_basic_data.address">
                {{
                org_basic_data.address
                }}
              </tr>
              <tr v-if="org_basic_data.phone">
                Phone :
                {{
                org_basic_data.phone
                }}
              </tr>
              <tr v-if="org_basic_data.email">
                Email :
                {{
                org_basic_data.email
                }}
              </tr>
              <tr v-if="org_basic_data.website">
                Website :
                {{
                org_basic_data.website
                }}
              </tr>
              </center>
              </td>
              <th v-if="org_basic_data.school_logo">
                <center>
                  <img :src="org_basic_data.school_logo" class="logo school-logo" alt="School Logo" />
                </center>
              </th>
              </tr>
              <!--  <tr>
                                      <td colspan="3">PRN No. : {{show_receipt.registration_number}}</td>
                                  </tr>
                                  <tr>
                                      <td colspan="3">Student Name : {{show_receipt.name}}</td>
                                  </tr>
                                  <tr>
                                      <td colspan="3">Student Copy</td>
                                  </tr>
                                  <tr>
                                      <td colspan="3">Fee Details For : {{show_receipt.ay}}</td>
                                  </tr>
                                  <tr>
                                      <td colspan="3">Standard : {{show_receipt.standard}}</td>
                                  </tr>
                                  <tr>
                                      <td colspan="3">
                                          Receipt Date : {{show_receipt.receipt_date}}
                                      </td>
                                  </tr> -->
              <tr>
                <td colspan="1">
                  PRN No. : {{ show_receipt.registration_number }}
                </td>
                <td colspan="1">Student Name : {{ show_receipt.name }}</td>
                <td colspan="1">Student Copy</td>
              </tr>
              <tr>
                <td colspan="1">Fee Details For : {{ show_receipt.ay }}</td>
                <td colspan="1">Standard : {{ show_receipt.standard }}</td>
                <td colspan="1">
                  Receipt Date : {{ show_receipt.receipt_date }}
                </td>
              </tr>
              <tr>
                <td colspan="2"><strong>Fee Type</strong></td>
                <td><strong> Fee Amount (Rs.)</strong></td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in show_receipt.component_list_tax_receipt" :key="item.id">
                <td colspan="2">
                  {{ item.feescomponentacademicyear_name }}
                </td>
                <td>{{ item.fee_amount }}</td>
              </tr>
              <tr>
                <td colspan="2">
                  <strong>Total Fee Amount</strong>
                </td>
                <td>{{ show_receipt.total_fees_amount }}.00</td>
              </tr>
              <tr>
                <td colspan="3">
                  <v-row dense class="ml-2">
                    <strong> Amount In Words : </strong>
                    {{ toWords(show_receipt.total_fees_amount) }}
                  </v-row>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <v-row dense class="ml-2">
                    <strong>Installment Wise Details</strong>
                  </v-row>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <v-simple-table dense class="elevation-1">
                    <thead>
                      <tr>
                        <td>
                          <center>No.</center>
                        </td>
                        <td>
                          <center>Receipt No.</center>
                        </td>
                        <td>
                          <center>Receipt Date</center>
                        </td>
                        <td>
                          <center>Amount Paid</center>
                        </td>
                        <td>
                          <center>Transaction ID </center>
                        </td>
                        <td>
                          <center>Payment Mode</center>
                        </td>
                        <!-- <td>
                          <center>Fine</center>
                        </td> -->
                      </tr>
                    </thead>
            <tbody>
              <tr v-for="(
                              item, index
                            ) in show_receipt.student_receipt_details" :key="item.id">
                <td>{{ index + 1 }}</td>
                <td>{{ item.receipt_no }}</td>
                <td>{{ item.receipt_date }}</td>
                <td>{{ item.amount }}</td>
                <td>{{ item.trans_id }}</td>
                <td>{{ item.payment_mode_name }}</td>
                <!-- <td>{{ item.fine }}</td> -->
              </tr>
            </tbody>
        </v-simple-table>
        </td>
        </tr>
        <tr>
          <td colspan="3">
            <v-row class="ml-2 mt-2"><strong>Note : </strong></v-row>
            <v-row class="ml-2">1. Fee once paid will not be refundable</v-row>
            <v-row class="ml-2">2. Late fee will have to be paid applicable</v-row>
            <v-row class="ml-2">3. Receipt should be produced any time if required for
              verification</v-row>
            <v-row class="ml-2 mb-2">4. This is computer generated receipt no signature
              required</v-row>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <strong>
              <center></center>
            </strong>
          </td>
          <td>
            <strong>
              <center></center>
            </strong>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <strong>
              <center>Accounts Officer</center>
            </strong>
          </td>
          <td>
            <strong>
              <center>Seal</center>
            </strong>
          </td>
        </tr>
        </tbody>
        </template>
        </v-simple-table>
      </v-card>
    </v-col>
  </v-row>
</div>
</div>
</template>
<script>
  import axios from "axios";
  import "@/assets/css/color.css"; // css needs to be imported for each dashboard
  export default {
    data() {
      return {
        lc_data: null,
        org_basic_data: null,
        mics_other_fees_student_records: [],
        student_outstanding_receipts: [],
        show_receipt: "",
        show_receipts_btn: false,
        radios: null,
      };
    },
    methods: {

      toWords(n) {
        const a = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
        const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
        const w = (num) =>
          num < 20 ? a[num] :
            num < 100 ? b[Math.floor(num / 10)] + (num % 10 ? ' ' + a[num % 10] : '') :
              num < 1000 ? a[Math.floor(num / 100)] + ' Hundred ' + (num % 100 ? w(num % 100) : '') :
                num < 100000 ? w(Math.floor(num / 1000)) + ' Thousand ' + (num % 1000 ? w(num % 1000) : '') :
                  num < 10000000 ? w(Math.floor(num / 100000)) + ' Lakh ' + (num % 100000 ? w(num % 100000) : '') :
                    w(Math.floor(num / 10000000)) + ' Crore ' + (num % 10000000 ? w(num % 10000000) : '');

        return w(n) + ' Rupees Only';
      },
      print() {
        alert("Printing...");
        this.$store.state.drawer = false;
        let that = this;
        window.onafterprint = function () {
          that.$store.state.drawer = true;
        };
        setTimeout(function () {
          window.print();
        }, 100);
      },
    },
    mounted() {
      this.mics_other_fees_student_records = JSON.parse(
        localStorage.getItem("mics_other_fees_student_records")
      );
      this.org_basic_data = JSON.parse(localStorage.getItem("org_basic_data"));
      this.student_outstanding_receipts = JSON.parse(
        localStorage.getItem("student_outstanding_receipts")
      );
      this.show_receipt = JSON.parse(localStorage.getItem("show_receipt"));
      this.show_receipts_btn = JSON.parse(
        localStorage.getItem("show_receipts_btn")
      );
      this.radios = JSON.parse(localStorage.getItem("radios"));
    },
  };
</script>
<style scoped>
  @media all and (max-width: 900px) {
    .padding-bot {
      padding: 8px;
    }
  }

  .mytable2 /deep/ thead th {
    background: #0f2027 !important;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right,
        #2c5364,
        #203a43,
        #0f2027) !important;
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important;
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
  }

  tr,
  td,
  th {
    border: 1px solid #ccc;
    text-align: center;
    font-size: small;
  }

  tr,
  tbody {
    border-bottom: 1px solid #ccc;
    border: 1px solid #ccc;
  }

  @media (min-width: 320px) {

    td,
    th {
      display: table-cell !important;
      font-size: small;
    }

    td+td,
    th+th {
      width: auto;
      font-size: small;
    }
  }

  v-simple-table {
    white-space: nowrap !important;
    text-align: center;
  }

  @media print {
    .element::-webkit-scrollbar {
      width: 0 !important;
    }

    header,
    footer,
    nav,
    date {
      display: none !important;
      overflow-x: hidden;
    }

    table,
    td,
    tr {
      break-inside: avoid-page;
    }

    img {
      width: 100% !important;
    }

    body,
    tr,
    th,
    td {
      font-size: large !important;
      font-weight: bold !important;
    }

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
      display: none !important;
    }

    @page {
      size: A4 landscape;
      margin-top: none;
      padding-top: none;
      /* size: 20.5in 15.5in; */
      size: 20.5in 19in;

      overflow-x: hidden;
      /* margin: 0; */
    }

    table,
    td,
    tr,
    th {
      text-align: center !important;
      margin-top: none;
      padding: 0.3rem !important;
      font-size: large !important;
      font-weight: bold !important;
      border-bottom: 1px solid black;
      border: 1px solid black;
      overflow-x: hidden;
      overflow-y: hidden;
    }

    .logo {
      display: block !important;
      margin-left: auto !important;
      margin-right: auto !important;
    }

    .trust-logo {
      max-width: 150px !important;
      height: auto !important;
    }

    .school-logo {
      max-width: 150px !important;
      height: auto !important;
    }
  }
</style>